import type { SVGProps } from 'react';

const SvgSearchMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303C20.8232 20.2374 20.8232 19.7626 20.5303 19.4697L20 20L19.4697 20.5303ZM17 10.5H16.25C16.25 13.6756 13.6756 16.25 10.5 16.25V17V17.75C14.5041 17.75 17.75 14.5041 17.75 10.5H17ZM10.5 17V16.25C7.32436 16.25 4.75 13.6756 4.75 10.5H4H3.25C3.25 14.5041 6.49594 17.75 10.5 17.75V17ZM4 10.5H4.75C4.75 7.32436 7.32436 4.75 10.5 4.75V4V3.25C6.49594 3.25 3.25 6.49594 3.25 10.5H4ZM10.5 4V4.75C13.6756 4.75 16.25 7.32436 16.25 10.5H17H17.75C17.75 6.49594 14.5041 3.25 10.5 3.25V4ZM15 15L14.4697 15.5303L19.4697 20.5303L20 20L20.5303 19.4697L15.5303 14.4697L15 15Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgSearchMd;
